import React from 'react';
import { Button } from '@mui/material';
import Modal from '../Modal/Modal';
import { brand } from '@/brand/brand';
import { useIsMobile } from '@/hooks/useIsMobile';

import styles from './twoFactorModal.module.css';

export default function TwoFactorModal({ handleCloseModal, handleContinue }) {
  const isMobile = useIsMobile();

  return (
    <Modal showClose={true} handleClose={handleCloseModal}>
      <div className={styles.modalWrapper}>
        <h2 className={styles.header} data-core-qa="mfaModalTitleText">
          Setup Two-Factor Authentication
        </h2>
        <div className={styles.modalSubText} data-core-qa="mfaModalSubText">
          <p>Two-Factor Authentication is now available!</p>
          <p>
            Security is critical at {brand.brandName}. To help keep your account safe, we
            will text you a verification code when you sign in.
          </p>
        </div>
        <div className={styles.modalButtonRow}>
          <Button
            className={styles.button}
            variant="outlined"
            data-core-qa="mfaModalButtonCancel"
            onClick={handleCloseModal}
            size="large"
            fullWidth={isMobile}
          >
            Cancel
          </Button>
          <Button
            className={styles.button}
            variant="contained"
            data-core-qa="mfaModalButtonContinue"
            onClick={handleContinue}
            size="large"
            fullWidth={isMobile}
          >
            Get Started
          </Button>
        </div>
      </div>
    </Modal>
  );
}
